import { render, staticRenderFns } from "./textareas.vue?vue&type=template&id=0faef06a&"
import script from "./textareas.vue?vue&type=script&lang=ts&"
export * from "./textareas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports